<template>
  <main class="main-tag">
    <div class="login-page login-page-default row" id="login-page">
      <div class="col-md-4 offset-md-4 col-sm-8 offset-sm-2 text-left pt-5">
        <h4 class="welcome-heading-text q-mb-sm ptl">
          Een ogenblik. Je wordt ingelogged.
        </h4>
      </div>
    </div>
  </main>
</template>

<script>
import { computed, onMounted } from "vue";
import store from "../store/index.js";
import { useRouter } from "vue-router";
import axios from "axios";
import axiosUrl from "../services/axios.service";

const API_URL = axiosUrl.getAxiosUrl();

export default {
  name: "AuthByToken",
  setup() {
    const router = useRouter();

    const isLoggedIn = computed({
      get: () => store.state.auth.isLoggedIn,
    });

    const urlParams = new URLSearchParams(window.location.search);

    onMounted(async () => {
      await axios
        .post(API_URL + "/users/authenticate-by-token", {
          username: urlParams.get("username"),
          token: urlParams.get("token"),
        })
        .then(async () => {
          location.href = process.env.VUE_APP_SAS_BASE_URL;
          return;
        })
        .catch(() => {
          router.replace({ path: "/geen-account" });
          return;
        });
    });

    return {
      router,
      isLoggedIn,
    };
  },
};
</script>
<style>
.ptl {
  padding-top: 100px;
}
</style>
